<template>
  <ExamStart :path="'/continueEdu'" style="margin-top: -120px;"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/questionnaire/start'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/questionnaire/start.vue